/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { OnboardingDatapointId } from "../../commons/types/OnboardingDatapointId";
import { OnboardingId } from "../../commons/types/OnboardingId";
export const OnboardingDatapoint = core.serialization.object({
    id: OnboardingDatapointId,
    onboardingId: OnboardingId,
    source: core.serialization.string().optional(),
    data: core.serialization.any(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
